import React from 'react'
import { CountdownCircleTimer } from 'react-countdown-circle-timer'

const renderTime = ({ remainingTime }) => {
  if (remainingTime === 0) {
    return <div className="timer">0</div>;
  }

  let minutes = Math.floor(remainingTime/60);
  let seconds = remainingTime % 60;


  if (seconds < 10 && minutes) {seconds = "0"+seconds;}


  return (
    <div className="timer">
      {minutes ? minutes + ': ' : null}{seconds}
    </div>
  );
};

function Timer({timeLimit, refreshImg, isPlaying, theme}) {


    return (

            <CountdownCircleTimer
              size={100}
              strokeLinecap="square"
              strokeWidth={10}
              isPlaying ={isPlaying}
              onComplete={() => {
                console.log('complete')
                refreshImg(); // this also resets the timer
              }}
              duration={timeLimit}
              trailColor={theme.palette.action.hover}
              colors={[
                [theme.palette.primary.main, 0.33],
              ]}
            >
              {renderTime}
            </CountdownCircleTimer>

    )
}

export default Timer
